var classes = {"colorSwatchRadioGroupInputs":"esX8i","colorSwatchRadioGroupInputsRow":"_2OENi","disabled":"I3KGL"};

export { classes as default };
